import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { useToast } from '@/hooks/use-toast';
import i18n_base_ui from '@/locales/keys/i18n_base_ui.json';
import i18n_errors from '@/locales/keys/i18n_errors.json';
import i18n_page_settings_user from '@/locales/keys/i18n_page_settings_user.json';
import { InputWithButtonEdit } from '@/pages/_base/inputs/InputWithButtonEdit';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { remote_user_settings_update_password } from '@/state/user/settings/remote_user_settings_update_password';
import { CONSTANTS__shared } from '@shared/constants/CONSTANTS__shared';
import { DTO_RESPONSE__success } from '@shared/network/DTO_RESPONSE__success';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import * as z from 'zod';

function InputUserPassword() {
  const dispatch = use_dispatch();
  const { t: t_ui } = useTranslation(ENUM__i18n_namespace.BASE_UI);

  const { toast } = useToast();
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_USER);

  const [value, set_value] = useState('');

  const schema_password = z.string().min(CONSTANTS__shared.USER_PASSWORD_LENGTH_MIN, t(i18n_errors.auth.password_length, { ns: ENUM__i18n_namespace.ERRORS }));

  /*
   * EVENTS
   */
  async function onChangeCommited(value: string) {
    onChange('');

    if (value.is_blank()) return;

    const validation_password = schema_password.safeParse(value);

    if (validation_password.error) {
      toast({
        title: t(i18n_errors.toast_title_response_error, { ns: ENUM__i18n_namespace.ERRORS }),
        description: [...validation_password.error.errors.map(err => err.message)].join('\n'),
      });
    }

    if (validation_password.success) {
      let result = await dispatch(remote_user_settings_update_password(value));

      if (result.payload instanceof DTO_RESPONSE__success) {
        toast({ title: t_ui(i18n_base_ui.toasts.change_user_password.title) });
      }
    }
  }

  function onChange(value: string) {
    set_value(value);
  }

  /*
   * RENDERS
   */

  return (
    <div className="flex gap-3 items-center">
      <h3 className="w-[10rem]">{t(i18n_page_settings_user.tabs.account.general_component.input.user_password.label)}:</h3>

      <InputWithButtonEdit
        value_default={''}
        {...{ onChangeCommited, onChange, value }}
        placeholder="●●●●●●●●"
        // password
        type="password"
        className="min-h-9 max-h-9 h-9"
      />
    </div>
  );
}

export default InputUserPassword;
